// import React from 'react'
// import './style.css'

// const NewBenefitsSection = () => {

//     const chatBotBenifits = [
//         {
//             title: "24/7 Customer Support",
//             description: "AI chatbots cater to global audiences beyond business hours."
//         },
//         {
//             title: "Cost Reduction",
//             description: "Chatbots can decrease service costs by up to 30-40% by handling routine inquiries & repetitive tasks, reducing the need for large support teams."
//         },
//         {
//             title: "Increased Efficiency",
//             description: "Streamline workflows by managing multiple conversations simultaneously, boosting efficiency by up to 50% & freeing agents for complex tasks."
//         },
//         {
//             title: "Lead Generation & Qualification",
//             description: "AI chatbots engage potential customers, capture information, & qualify leads automatically for sales teams."
//         },
//         {
//             title: "Recruitment Support Available",
//             description: "Automate pre-screening with conversational AI to quickly identify qualified candidates & improve hiring efficiency."
//         },
//         {
//             title: "Easier Checkout Processes",
//             description: "Guide customers smoothly, answer queries, & resolve payment issues, reducing cart abandonment & increasing conversions."
//         },
//         {
//             title: "Better Consumer Insights",
//             description: "Collect & analyze customer interactions to provide valuable insights that improve products, services, & the overall customer experience."
//         },
//         {
//             title: "Omnichannel User Support",
//             description: "Provide consistent, real-time assistance across websites, social media, & messaging apps, strengthening brand presence & loyalty."
//         },
//         {
//             title: "Easy Integration",
//             description: "Integrate seamlessly with existing systems, offering advanced automation without complex setup, while maintaining efficiency & user-friendly operations."
//         }
//     ];

//     return (
//         <>
//             {/* <section className="new-benefits-section">
//                 <div className="container">
//                     <h2 className='low-top-heading'>Benefits Of AI Customer Service Chatbots</h2>
//                     <p className='benefits-section-heading-text'>Delivering <span>Operational</span> Excellence, Creating Lasting Customer Value</p>
//                     <p className="lead">There are numerous benefits of AI customer service chatbots for businesses, as they provide instant, personalized support while boosting efficiency & reducing operational costs. Some top benefits of AI chatbots powered by LLM technologies.</p>
//                     <div className="row g-4">
//                         {chatBotBenifits?.map((card, index) => {
//                             return <div className="col-md-4" key={index}>
//                                 <div className="new-benefits-card">
//                                     <div className="icon">🤖</div>
//                                     <h5>{card?.title}</h5>
//                                     <p>{card?.description}</p>
//                                 </div>
//                             </div>
//                         })}
//                     </div>
//                 </div>
//             </section> */}

//             <div className="new-benefits-section">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-xl-6">
//                             <div className="benifits-chalanges-section-conent">
//                                 <h2 className='low-top-heading'>Benefits Of AI Customer Service Chatbots</h2>
//                                 <h4>Delivering <span>Operational Excellence</span> Creating Lasting Customer Value</h4>
//                                 <p className="description-text-white">There are numerous benefits of AI customer service chatbots for businesses, as they provide instant, personalized support while boosting efficiency & reducing operational costs.</p>
//                             </div>
//                         </div>

//                         <div className="col-md-6">
//                             {chatBotBenifits?.map((item, index) => {
//                                 return <div className="benifits-chalanges-content-box" key={index}>
//                                     <h4>{item?.title}</h4>
//                                     <p className="description-text-white">{item?.description}</p>
//                                 </div>
//                             })}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default NewBenefitsSection

import React from 'react'
import './style.css'
import Button from '../CtaButton'

const NewBenefitsSection = () => {

    const chatbotBenefitsData = [
        {
            badge: "24/7 Customer Support",
            heading: "Deliver Instant Help, Anytime.",
            descriptionPoints: [
                "Provide real-time support beyond business hours",
                "Automate answers for FAQs & service requests",
                "Handle thousands of conversations simultaneously",
                "Support global audiences in multiple languages",
                "Reduce response time & improve satisfaction",
            ],
            image: "/images/chatbot-intigration-vectors/deliver-instant.avif",
            btnText: "Automate Support Now",
            btnLink: "/contact-us"
        },
        {
            badge: "Cost Reduction",
            heading: "Cut Service Costs <br/> Boost ROI.",
            descriptionPoints: [
                "Automate repetitive tasks & inquiries",
                "Reduce dependency on large support teams",
                "Save up to 40% in customer service expenses",
                "Focus human agents on complex, high-value issues",
                "Lower overall operational overhead",
            ],
            image: "/images/chatbot-intigration-vectors/cut-services.avif",
            btnText: "Save With Chatbots",
        },
        {
            badge: "Increased Efficiency",
            heading: "Streamline Conversations at Scale.",
            descriptionPoints: [
                "Manage multiple customer chats simultaneously",
                "Automate workflows for faster issue resolution",
                "Improve agent productivity by up to 50%",
                "Shorten response & resolution times",
                "Enable smooth handoffs between AI & humans",
            ],
            image: "/images/chatbot-intigration-vectors/stream-conversation.avif",
            btnText: "Automate with Chatbots",
        },
        {
            badge: "Lead Generation & Qualification",
            heading: "Turn Conversations Into Conversions.",
            descriptionPoints: [
                "Capture potential leads through chat interactions",
                "Qualify leads automatically for your sales pipeline",
                "Collect customer intent data in real time",
                "Personalize follow-ups based on behavior",
                "Boost conversion rates with proactive engagement",
            ],
            image: "/images/chatbot-intigration-vectors/chatbot-benifit.avif",
            btnText: "Generate Leads Faster",
        },
        {
            badge: "Easier Checkout Experience",
            heading: "Simplify Every Customer Purchase.",
            descriptionPoints: [
                "Guide users through checkout via chat",
                "Resolve payment or shipping issues instantly",
                "Reduce cart abandonment",
                "Offer product recommendations on demand",
                "Increase completed transactions effortlessly",
            ],
            image: "/images/chatbot-intigration-vectors/simplify-customers.avif",
            btnText: "Boost Checkout Efficiency",
        },
        {
            badge: "Omnichannel User Support",
            heading: "Stay Connected Everywhere.",
            descriptionPoints: [
                "Deliver consistent support across web, mobile, & social apps",
                "Integrate with WhatsApp, Messenger, & more",
                "Maintain unified brand voice & tone",
                "Sync chat history across platforms",
                "Strengthen loyalty through seamless experiences",
            ],
            image: "/images/chatbot-intigration-vectors/stay-connected.avif",
            btnText: "Streamline User Support",
        },
        {
            badge: "Easy Integration",
            heading: "Automate Without the Complexity.",
            descriptionPoints: [
                "Connect effortlessly with CRM, ERP, or CMS",
                "Enable cross-platform automation & data sync",
                "Maintain user-friendly operations",
                "Scale without infrastructure strain",
                "Launch faster with minimal technical setup",
            ],
            image: "/images/chatbot-intigration-vectors/automated.avif",
            btnText: "Integrate AI Seamlessly",
        },
    ];

    return (
        <>
            <section className="new-benifits-section-updated-design-main-container">
                <div className="container new-benifits-section-updated-design-wrapper">
                    <div className="row align-items-center">

                        <div className="col-md-12 mb-5">
                            <h2 className='low-top-heading'>Benefits Of AI Customer Service Chatbots</h2>
                            <p className='benefits-section-heading-text'>Delivering <span>Operational</span> Excellence, Creating Lasting Customer Value</p>
                            <p className="description-text">There are numerous benefits of AI customer service chatbots for businesses, as they provide instant, personalized support while boosting efficiency & reducing operational costs. Some top benefits of AI chatbots powered by LLM technologies.</p>
                        </div>

                        <div className="col-md-12">
                            {chatbotBenefitsData.map((item, index) => (
                                <div className={`new-benefit-section-updated-card-design ${index % 2 !== 0 ? "dark-benifits-section-box" : ""}`} key={index}>
                                    <div className="container">
                                        <div
                                            className={`row align-center-card-image ${index % 2 !== 0 ? "reverse-row-after-one-row" : ""}`}
                                        >
                                            <div className="col-xl-6 col-lg-6 col-md-4">
                                                <div className="new-benifits-section-card-image">
                                                    <img src={item.image} alt={item.badge} />
                                                </div>
                                            </div>

                                            <div className="col-xl-6 col-lg-6 col-md-8">
                                                <div className="new-benifits-section-updated-design-content-col">
                                                    <div className="new-benifits-section-updated-design-badge new-benifits-section-updated-design-pink-bg">
                                                        <h6 className="new-benifits-section-updated-design-badge-text">
                                                            {item.badge}
                                                        </h6>
                                                    </div>

                                                    <h2 className="new-benifits-section-updated-design-heading display-5 fw-bold mb-4" dangerouslySetInnerHTML={{ __html: item.heading }}>
                                                    </h2>

                                                    <ul className="new-benifits-section-updated-design-benefits-list list-unstyled new-benifits-section-updated-design-checkmark-list mb-5">
                                                        {item.descriptionPoints.map((point, i) => (
                                                            <li key={i} className="mb-2">
                                                                {point}
                                                            </li>
                                                        ))}
                                                    </ul>

                                                    <Button text={item.btnText} link="/contact-us" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NewBenefitsSection